<template>
  <v-sheet class="wall-with-floor-background" height="100%">
    <v-row class="fill-height" align="center" justify="center">
      <v-col :cols="columns" class="survey-card">
        <v-card class="slide-card">
          <v-img src="../../../public/static/Text Background 1.png" />
          <div class="slide-content" style="padding:5%">
            <v-row>
              <v-col cols="12">
                <p class="question-font">
                  {{ $t(`message.slideSixteenContext`) }}
                </p>
              </v-col>
            </v-row>
            <v-divider></v-divider>
            <br />
            <v-row>
              <v-col cols="12">
                <p class="question-font">
                  {{ $t(`message.slideSixteenQuestionOne`) }}
                </p>
              </v-col>
              <v-col cols="12">
                <v-radio-group
                  row
                  v-model="questions.TransitNeeds"
                  :style="$vuetify.breakpoint.xs ? `margin-left: 7%` : ``"
                >
                  <v-radio
                    :label="$t(`message.RadioGroupYesLabel`)"
                    value="yes"
                  ></v-radio>
                  <v-radio
                    :label="$t(`message.RadioGroupNoLabel`)"
                    value="no"
                  ></v-radio>
                  <v-radio
                    :label="$t(`message.Exercise4RadioGroupNoOpinionLabel`)"
                    value="noOpinion"
                  ></v-radio>
                </v-radio-group>
              </v-col>
            </v-row>
            <v-divider></v-divider>
            <br />
            <template v-if="isAreaMap">
              <v-row>
                <v-col cols="12">
                  <p class="question-font">
                    {{ $t(`message.slideSixteenSelectOneQuestion`) }}
                  </p>
                  <v-select
                    v-model="questions.TransitNeedsAreas"
                    :items="$t(`message.Exercise4SelectOneChoices`)"
                    item-text="label"
                    item-value="value"
                    return-object
                    multiple
                    required
                  ></v-select>
                </v-col>
              </v-row>
              <v-divider></v-divider>
              <br />
            </template>
            <v-card-actions v-if="!surveyMode">
              <v-col class="text-right">
                <v-btn class="white--text" color="#015594" @click="nextSlide">{{
                  $t(`message.continue`)
                }}</v-btn>
              </v-col>
            </v-card-actions>
          </div>
          <v-img src="../../../public/static/Text Background 2.png" />
        </v-card>
      </v-col>
      <v-col
        :cols="columns"
        align="center"
        justify="center"
        style="padding-bottom: 0%;"
      >
        <v-img src="../../../public/static/Easel Top.png" :width="easelTop" />
        <div
          @click="toggleMap5 = true"
          style="cursor: pointer; width: fit-content"
        >
          <v-img
            v-if="!isAreaMap"
            src="../../../public/static/Exercise 4/Map5.jpg"
            width="650"
            contain
          />
          <v-img
            v-else
            src="../../../public/static/Exercise 4/AreaMap.jpg"
            width="650"
            contain
          />
        </div>
        <v-img
          src="../../../public/static/Easel Bottom.png"
          :width="easelBottom"
          eager
        />
      </v-col>
      <v-dialog v-model="toggleMap5">
        <div class="text-right" style="background: antiquewhite;">
          <v-btn class="text-right" @click="toggleMap5 = false"> X </v-btn>
        </div>
        <v-card color="gray" class="gray-background">
          <v-img
            v-if="!isAreaMap"
            src="../../../public/static/Exercise 4/Map5.jpg"
            contain
            style="height: 125vh;"
          />
          <v-img
            v-else
            src="../../../public/static/Exercise 4/AreaMap.jpg"
            contain
            style="height: 125vh;"
          />
        </v-card>
      </v-dialog>
    </v-row>
  </v-sheet>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "ExistingPlannedFacility",
  props: {
    nextSlide: { type: Function },
    file: { type: String },
    slideNumber: { type: Number },
    updateFile: { type: Function },
    surveyMode: { type: Boolean }
  },
  mounted() {
    this.newSlideNumber = this.slideNumber;
    this.audio = new Audio(this.file);
    this.audio.play();
  },
  data() {
    return {
      toggleMap5: false,
      questions: {
        TransitNeeds: "",
        TransitNeedsAreas: []
      },
      audio: null,
      newSlideNumber: null
    };
  },
  watch: {
    "questions.TransitNeeds"(val) {
      if (val === "yes" || val === "noOpinion") {
        this.questions.TransitNeedsAreas = [];
      }
    },
    questions: {
      handler(val) {
        this.addExcercise4Response(val);
      },
      deep: true
    },
    "$i18n.locale": function() {
      if (this.newSlideNumber === 15) {
        this.audio.pause();
        this.audio.currentTime = 0;
        this.updateFile(15);
        this.audio = new Audio(this.file);
        this.audio.play();
      }
    },
    slideNumber(current) {
      this.newSlideNumber = current;
      if (current !== 15) {
        this.audio.pause();
        this.audio.currentTime = 0;
      } else {
        this.audio = new Audio(this.file);
        this.audio.play();
      }
    }
  },
  computed: {
    easelTop() {
      if (this.$vuetify.breakpoint.xs) {
        return "40%";
      }
      return "10%";
    },
    easelBottom() {
      if (this.$vuetify.breakpoint.xs) {
        return "100%";
      }
      return "33%";
    },
    columns() {
      if (this.$vuetify.breakpoint.xs) {
        return 12;
      }
      return 6;
    },
    isAreaMap() {
      return this.questions.TransitNeeds === "no";
    }
  },
  methods: {
    ...mapActions({
      addExcercise4Response: "response/addExcercise4Response"
    })
  }
};
</script>

<style scoped>
.question-font {
  font-size: 1em !important;
}
.survey-card {
  padding: 0% 0% 0% 7.5%;
  max-height: 75vh;
  overflow-y: auto;
}
@media (min-width: 350px) and (max-width: 1023px) {
  .survey-card {
    padding: 0%;
    max-height: 100%;
  }
}
</style>
